<template>
  <div>
    <v-divider/>
    <v-list-tile>
      <v-list-tile-avatar size="20" class="list-avatar-icon">
        <v-tooltip bottom>
          <v-icon slot="activator">info</v-icon>
          <span>{{translatedText}}</span>
        </v-tooltip>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <span class="caption prevent-overflow">{{placeholder.placeholderIdentifier}}</span>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn :id="placeholderId" :aria-label="placeholderId" icon @click="clickClipboard">
          <v-icon v-if="!placeholder.clipped">bookmark_border</v-icon>
          <v-icon v-else>bookmark</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>
<script>
  import {
    PLACEHOLDER_COPY_TO_CLIPBOARD,
    PLACEHOLDER_RESET_CLIPBOARD,
    SET_INFORMATION_TOASTER_STATE,
    SET_INFORMATION_TOASTER_TEXT
  } from '../../../store/mutation-types'
  import { informationTexts } from '../../../store/modules/information'

  export default {
    name: 'placeholder-item',
    props: {
      placeholder: {
        type: Object
      },
      placeholderKey: {
        type: Number
      }
    },
    methods: {
      clickClipboard () {
        this.$store.commit(PLACEHOLDER_RESET_CLIPBOARD)
        this.$store.commit(PLACEHOLDER_COPY_TO_CLIPBOARD, {id: this.placeholder.id, clipped: !this.placeholder.clipped})
        this.copyToClipboard()
      },
      copyToClipboard () {
        let body = document.getElementsByTagName('body')[0]
        let clipboardText = this.placeholder.placeholderIdentifier

        let tempInput = document.createElement('INPUT')
        body.appendChild(tempInput)
        tempInput.setAttribute('value', clipboardText)
        tempInput.select()
        let successful = document.execCommand('copy')
        // hide temp input after copying
        tempInput.style.display = 'none'
        if (successful) {
          this.$store.commit(SET_INFORMATION_TOASTER_TEXT, informationTexts.COPY_TO_CLIPBOARD)
          this.$store.commit(SET_INFORMATION_TOASTER_STATE, true)
        }
      }
    },
    computed: {
      placeholderId () {
        return `copy-${this.buildId}`
      },
      buildId () {
        return this.placeholder.placeholderIdentifier.replace('{', '').replace('}', '').replace(RegExp('_', 'g'), '-').toLowerCase()
      },
      translatedText () {
        let key = `admin.alerts.new.placeholders.items.${this.placeholder.id}`
        if (this.$i18n.keyExists(key)) {
          return this.$t(key)
        } else {
          return this.placeholder.placeholderIdentifier
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/PlaceholderItem.vue